import _defaults from 'lodash/defaults'

export default {
  getters: {
    Calendar: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].calendar
          : {},
        {
          'section-heading': 'Calendar',
          'section-subheading': ''
        }
      )
    }
  }
}
